//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { exportFile } from "quasar";
import { mapState } from "vuex";
import router from "../../router";

function wrapCsvValue(val, formatFn) {
  let formatted = formatFn !== void 0 ? formatFn(val) : val;
  formatted =
    formatted === void 0 || formatted === null ? "" : String(formatted);
  formatted = formatted.split('"').join('""');
  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')
  return `"${formatted}"`;
}

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "productNumber",
        descending: false,
      },
      stocks: [],
      Warehouses: [],
      Locations: [],

      headerTitle: "",
      stockLinesPost: [],
      disable: false,
      confirmComplete: false,
      confirmDelete: false,

      filter: "",

      dense: true,

      columns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: "productNumber",
          style: "width: 300px",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: "productName",

          sortable: true,
        },

        {
          name: "warehouseId",
          align: "left",
          label: "Lager",
          field: "warehouseId",
          sortable: true,
        },
        {
          name: "locationId",
          align: "left",
          label: "Lokasjon",
          field: "locationId",
          sortable: true,
        },
        {
          name: "pickedBy",
          align: "left",
          label: "Telt av",
          field: "pickedBy",
          sortable: true,
        },

        {
          name: "quantity",
          align: "right",
          label: "Antall",
          style: "width: 200px",
          field: "quantity",
          sortable: true,
        },
        {
          name: "quantityAdjusted",
          align: "right",
          style: "width: 200px",
          label: "Antall telt",
          field: "quantityAdjusted",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("main", ["warehouses", "locations"]),
  },

  methods: {
    exportTable() {
      // naive encoding to csv format

      var content = [
        this.columns.map((col) => wrapCsvValue(col.label)).join(";"),
      ]
        .concat(
          this.stocks.map((row) =>
            this.columns
              .map((col) =>
                wrapCsvValue(
                  typeof col.field === "function"
                    ? col.field(row)
                    : row[col.field === void 0 ? col.name : col.field],
                  col.format
                )
              )
              .join(";")
          )
        )
        .join("\r\n");
      var BOM = "\uFEFF";
      content = BOM + content;
      const status = exportFile("table-export.csv", content, "text/csv");
      if (status !== true) {
        this.$q.notify({
          message: "Browser denied file download...",
          color: "negative",
          icon: "warning",
        });
      }
    },

    async fetchStock(id) {
      const stocks = await this.getStocksIncludeEmpty();
      const countingStocks = await this.getCountingStocks();
      const counting = await this.getCounting(id);
      console.log(counting);
      this.headerTitle = id.toString() + " - " + counting.name;

      this.stocks = stocks;
      countingStocks.forEach((countingStock) => {
        if (countingStock.countingId == id) {
          this.stocks.forEach((stock) => {
            if (stock.id == countingStock.stockId) {
              stock.quantityAdjusted = countingStock.quantity;
              stock.pickedBy = countingStock.createdByName;
            }
          });
        }
      });
      if (counting.completed || counting.canceled) {
        this.disable = true;
      }
    },

    async refresh() {
      this.fetchStock(this.id);
    },

    async newStock() {
      console.log("ny telling");
      const data = await this.getStocks();
      console.log(data);
      this.stocks = data;
    },
    postRow(row) {
      console.log(row);
      if (this.stockLinesPost.length > 0) {
        const index = this.stockLinesPost.findIndex(
          (x) => x.stockId === row.id
        );
        console.log(index);
        if (index > -1) {
          console.log("finnes en fra før");
          this.stockLinesPost.splice(index, 1);
        }
      }

      var cs = {};
      cs["countingId"] = parseInt(this.id);
      cs["stockId"] = row.id;
      cs["quantity"] = row.quantityAdjusted;
      this.stockLinesPost.push(cs);
      console.log(cs);
      console.log(this.stockLinesPost);
    },
    async completeStock() {
      try {
        var message = await this.postCountingComplete(this.id);
        console.log(message);
        this.stockLinesPost = [];
        this.disable = true;
        this.$notify({
          group: "foo",
          title: "",
          text: this.$t("common.saveOk"),
        });
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
    },
    async saveStock() {
      try {
        if (this.stockLinesPost.length > 0) {
          var updatedDto = await this.postCountingStocks(this.stockLinesPost);
          console.log(updatedDto);
          this.stockLinesPost = [];
          this.$notify({
            group: "foo",
            title: "",
            text: this.$t("common.saveOk"),
          });
        } else {
          this.$notify({
            group: "foo",
            title: "",
            text: this.$t("common.saveOk"),
          });
        }
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
      this.refresh();
    },
    async delStock() {
      try {
        var message = await this.postCountingCancel(this.id);
        console.log(message);

        this.$notify({
          group: "foo",
          title: "",
          text: this.$t("common.deleteMessage"),
        });
        router.push({
          name: "StockCountings",
        });
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
    },

    ...mapActions("main", [
      "getCountings",
      "getCounting",
      "getCountingStocks",
      "getCountingStock",
      "getArticles",
      "getStocks",
      "postCountingStocks",
      "postCountingComplete",
      "postCountingCancel",
      "getStocksIncludeEmpty",
    ]),
  },
  created() {
    this.Warehouses = this.warehouses;
    this.Locations = this.locations;
    this.id = this.$route.params.id;
    this.fetchStock(this.id);
  },
};
